/* eslint-disable camelcase */
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiClient from 'src/api/api-client';
import { getContactURI, updateContactStatusURI } from '../api';
import { setValue } from './MessageSlice';
// First, create the thunk
export const fetchContact = createAsyncThunk(
  'CV/fetchContact',
  async (params, { rejectWithValue, dispatch }) => {
    try {
      const response = await apiClient
        .handleRequest({
          method: 'get',
          url: `${getContactURI}`,
          params: { ...params },
        })
        .then(res => res.data);
      return response.data;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);
export const updateContactStatus = createAsyncThunk(
  'CV/updateContactStatus',
  async (data, { rejectWithValue, dispatch }) => {
    try {
      await apiClient
        .handleRequest({
          method: 'post',
          url: `${updateContactStatusURI(data.id)}`,
          data,
        })
        .then(res => res.data);
      return data.status;
    } catch (err) {
      dispatch(setValue({ show: true, body: err.message }));
      if (!err.response) {
        throw err;
      }
      return rejectWithValue(err.response.data);
    }
  },
);

// Then, handle actions in your reducers:
const contactSlice = createSlice({
  name: 'cv',
  initialState: {
    entities: [],
    loading: 'idle',
    saving: 'idle',
    saving_id: 0,
    currentRequestId: undefined,
    error: null,
    currentPage: 1,
    totalPage: 1,
    total: 0,
  },
  reducers: {
    // standard reducer logic, with auto-generated action types per reducer
  },
  extraReducers: {
    [fetchContact.pending]: (state, action) => {
      if (state.loading === 'idle') {
        state.loading = 'pending';
        state.currentRequestId = action.meta.requestId;
      }
    },
    // Add reducers for additional action types here, and handle loading state as needed
    [fetchContact.fulfilled]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        const { data, last_page, current_page, total } = action.payload;
        state.loading = 'idle';
        state.entities = data;
        state.currentPage = current_page;
        state.totalPage = last_page;
        state.currentRequestId = undefined;
        state.total = total;
      }
    },
    [fetchContact.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.loading === 'pending' && state.currentRequestId === requestId) {
        state.loading = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },

    [updateContactStatus.pending]: (state, action) => {
      if (state.saving === 'idle') {
        state.saving = 'pending';
        state.saving_id = action.meta.arg.id;
        state.currentRequestId = action.meta.requestId;
      }
    },
    [updateContactStatus.fulfilled]: (state, action) => {
      state.saving = 'idle';
      const { id, status } = action.meta.arg;
      const idx = state.entities?.findIndex(i => i.id === id);
      if (idx !== -1) {
        state.entities[idx].status = status;
      }
    },
    [updateContactStatus.rejected]: (state, action) => {
      const { requestId } = action.meta;
      if (state.saving === 'pending' && state.currentRequestId === requestId) {
        state.saving = 'idle';
        state.error = action.error;
        state.currentRequestId = undefined;
      }
    },
  },
});

export default contactSlice.reducer;
